import { render, staticRenderFns } from "./DeliveryOptionComponent.vue?vue&type=template&id=5ad1dc2d&scoped=true&"
import script from "./DeliveryOptionComponent.vue?vue&type=script&lang=js&"
export * from "./DeliveryOptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOptionComponent.vue?vue&type=style&index=0&id=5ad1dc2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1dc2d",
  null
  
)

export default component.exports